import { render, staticRenderFns } from "./judges.vue?vue&type=template&id=765c4b94"
import script from "./judges.vue?vue&type=script&lang=js"
export * from "./judges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports